module.exports = {"411481001":"演集街道","411481002":"崇法寺街道","411481003":"侯岭街道","411481004":"沱滨街道","411481005":"日月湖街道","411481006":"雪枫街道","411481102":"芒山镇","411481103":"高庄镇","411481104":"酂城镇","411481105":"裴桥镇","411481106":"马桥镇","411481107":"薛湖镇","411481108":"蒋口镇","411481109":"陈集镇","411481110":"十八里镇","411481111":"太丘镇","411481112":"李寨镇","411481113":"苗桥镇","411481114":"顺和镇","411481115":"茴村镇","411481116":"酂阳镇","411481117":"龙岗镇","411481118":"马牧镇","411481119":"大王集镇","411481120":"刘河镇","411481121":"双桥镇","411481122":"卧龙镇","411481123":"黄口镇","411481124":"新桥镇","411481125":"条河镇","411481219":"陈官庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411481.json
// module id = 1785
// module chunks = 0